import { useMemo } from 'react';
import { getNavIcon } from '@/lib/navigation-icons';
import { useNavigationApi, resolveNodeRoute, resolveIcon, type NavigationLink } from './useNavigationApi';
import { type LucideIcon } from 'lucide-react';

export interface SidebarLink {
  title: string;
  url: string;
  icon: LucideIcon;
}

const mockQuickLinks: SidebarLink[] = [
  { title: "HIN/Unit Search", url: "/units", icon: getNavIcon("UnitSearch_Link") },
  { title: "Parts Search", url: "#", icon: getNavIcon("PartsSearch_Link") },
  { title: "Dealer Orders", url: "/orders", icon: getNavIcon("DealersOrders_Link") },
  { title: "Parts Invoice", url: "#", icon: getNavIcon("PartsInvoice_Link") },
  { title: "Reports", url: "#", icon: getNavIcon("Reports_Link") },
  { title: "Spiffs", url: "#", icon: getNavIcon("Spiffs_Link") },
  { title: "Claims and Pre-Auths", url: "/dealer-claims", icon: getNavIcon("ClaimsAndPreAuths_Link") },
  { title: "Warranty Registration", url: "/warranty-registration", icon: getNavIcon("WarrantyRegistration_Link") },
  { title: "Service Campaigns", url: "/service-campaigns", icon: getNavIcon("ServiceCampaigns_Link") },
];

export function useSidebarNavigation() {
  const { nodes, isLoading, useMock } = useNavigationApi({
    rootNavigationTag: 'QuickLinks',
  });

  const apiLinks = useMemo<SidebarLink[] | null>(() => {
    if (!nodes) return null;
    return nodes
      .filter((node: any) => node.showInMenu !== false)
      .map((node: any) => {
        const title = node.name || '';
        return {
          title,
          url: resolveNodeRoute(node),
          icon: resolveIcon(node.navigationTag),
        };
      });
  }, [nodes]);

  return {
    quickLinks: useMock ? mockQuickLinks : (apiLinks ?? []),
    isLoading,
    isMock: useMock,
  };
}
